import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
// import TablesTemplate from './table_template';
import { ADD_ROW, DELETE_ROW, JSON_KEY_INSTRUMENT, UPDATE_ROW, TABLE_HEADER_TOTAL,
   TABLE_HEADER_AVAILABLE, JSON_KEY_AVAILABLE, JSON_KEY_TRADING_ACCOUNT,
   TABLE_HEADER_TRADING_ACCOUNT, JSON_KEY_TOTAL, INSTRUMENT_TYPE_NAME_CURRENCY,
   FormatWithDecimals, JSON_KEY_SELL_PENDING_APPROVAL, JSON_KEY_BUY_PENDING_APPROVAL, TABLE_HEADER_BUY_PENDING_APPROVAL,
   TABLE_HEADER_SELL_PENDING_APPROVAL, TABLE_HEADER_HOLDINGS,
   INSTRUMENT_TYPE_NAME_CRYPTO_CURRENCY,
   DELETE_TABLE,
   instrumentCodeColor,
   JSON_KEY_STATUS,
   statusTextColor, 
   // TABLE_HEADER_STATUS, JSON_KEY_STATUS
   // TABLE_HEADER_CODE, JSON_KEY_CODE, 
   // JSON_KEY_ID, TABLE_HEADER_ID, 
   } from '../../common/common';
import { useSelector } from 'react-redux';
import { selectHoldingsRequest, selectIsMarketController, selectTableData, selectTSUserId } from '../../redux/globalsSlice';
import { Modal } from 'react-bootstrap';
import HoldingsAdminForm from '../forms/holdings_admin_form';
import { selectAccounts, selectHoldings } from '../../redux/dropDownSlice';
import VirtualizedTablesTemplate from './VirtualizedTablesTemplate';
import HoldingsRequestForm from '../forms/holdings_request';

const Holdings2 = () => {
   const instrumentsTableData = useSelector(selectTableData); // ✅ get full table data from redux
   const instrumentsTableDataRef = useRef({});
   const [showRequestForm, setShowRequestForm] = useState(null);   
   const tsUserId = useSelector(selectTSUserId);
   const [showForm, setShowForm] = useState(false);
   const [selectedRow, setSelectedRow] = useState(null);
   const tsUserIdRef = useRef(tsUserId);
   const isMarketController = useSelector(selectIsMarketController);
   const isMarketControllerRef = useRef(isMarketController);
   const dropDownHoldingsData = useSelector(selectHoldings);
   // const dropDownInstrumentsData = useSelector(selectInstruments);
   const dropDownTradingAccountsData = useSelector(selectAccounts);
   const requestForm = useSelector(selectHoldingsRequest);
   const requestFormRef = useRef(requestForm);
   
   useEffect(() => {
      requestFormRef.current = requestForm;
   }, [requestForm]);

   useEffect(() => {
      tsUserIdRef.current = tsUserId;
   }, [tsUserId]);

   useEffect(() => {
      isMarketControllerRef.current = isMarketController;
   }, [isMarketController]);
   
   const handleCloseForm = () => {
      setShowForm(false); 
      setSelectedRow(null);
   };

   useEffect(() => {
      instrumentsTableDataRef.current = instrumentsTableData;
   }, [instrumentsTableData]);
   
   const handleSingleClick = useCallback((rowData) => {
      // console.log(`[HoldingsTable] Row Clicked:`, rowData, `, isMarketControllerRef.current: `, isMarketControllerRef.current);
      if (isMarketControllerRef.current) {
         if (requestFormRef.current) {
            setSelectedRow(rowData);
            setShowRequestForm(true);
         }
      }
   }, []);

   const handleDoubleClick = useCallback((rowData) => {
      // console.log(`[HoldingsTable] Row Double Clicked:`, rowData, `, isMarketControllerRef.current: `, isMarketControllerRef.current);
      if (isMarketControllerRef.current) {
         setSelectedRow(rowData);
         setShowForm(true);          
      }
   }, []);
   
   const handleEmptyTableClick = useCallback((rowData) => {
      // console.log('[HoldingsTable] Empty Row Double Clicked, showRequestForm:', requestFormRef.current);
      if (isMarketControllerRef.current) {
         if (requestFormRef.current) {
            setSelectedRow(rowData);
            setShowRequestForm(true);
         }
      }
   }, []);
   
   const handleCloseRequestForm = () => {
      setShowRequestForm(false);
      setSelectedRow(null);
   };

   const handleEvents = useCallback((details, setLocalTableData) => {
      const code = details.data.instr;
      const instrumentRow = instrumentsTableDataRef.current[code];
      if (!instrumentRow && (details.type !== DELETE_TABLE)) return;

      const type = instrumentRow?.i_type ?? 0;
      const decimal_places = (type === INSTRUMENT_TYPE_NAME_CURRENCY || type === INSTRUMENT_TYPE_NAME_CRYPTO_CURRENCY)
                              ? instrumentRow?.price_dec ?? 0 : instrumentRow?.qty_dec ?? 0;

      // console.log('holdings, data: ', details.data, ', type: ', type, ', decimal_places: ', decimal_places);
      // console.log('instrumentRow: ', instrumentRow);

      const modifiedRow = {
         ...details.data,
         avail: FormatWithDecimals(details.data.avail, decimal_places),
         tot: FormatWithDecimals(details.data.tot, decimal_places),
         used: FormatWithDecimals(details.data.used, decimal_places),
         b_pend: FormatWithDecimals(details.data.b_pend, decimal_places),
         s_pend: FormatWithDecimals(details.data.s_pend, decimal_places),
         id: details.data.code,
         // status: ConvertStatus(details.data.status),         
      };
      
      // console.log('Holdings Table Event Received: ', details.type, ', modifiedRow: ', modifiedRow);
      switch (details.type) {
         case ADD_ROW: {
            setLocalTableData(prev => {
               const exists = prev.some(row => row.id === modifiedRow.id);
               if (exists) {
                  console.log(`Duplicate holdings with id ${modifiedRow.id} ignored.`);
                  return prev;
               }
               return [...prev, modifiedRow];
            });
            break;
         }

         case UPDATE_ROW:
            setLocalTableData(prevData => prevData.map(row => row.id === modifiedRow.id ? modifiedRow : row));
            break;

         case DELETE_ROW:
            setLocalTableData(prevData => prevData.filter(row => row.id !== modifiedRow.id));
            break;

         case DELETE_TABLE:
            // console.log("Holdings Table - delete all rows event received.");
            setLocalTableData([]);                     
            break;
            
         default:
            break;
      }
   }, []);

   const columnStyling = useMemo(() => {
      const base = {};
      base[JSON_KEY_TRADING_ACCOUNT] = (rowData) => ({
         color: instrumentCodeColor(rowData.status),
      });
      base[JSON_KEY_STATUS] = (rowData) => ({
         color: statusTextColor(rowData.status),
      });
      return base;
   }, []);
   
   const columns = useMemo(() => [
      // { Header: TABLE_HEADER_ID, accessor: JSON_KEY_ID, }, // dont show it but it is still there
      // { Header: TABLE_HEADER_CODE, accessor: JSON_KEY_CODE },
      { Header: TABLE_HEADER_TRADING_ACCOUNT, accessor: JSON_KEY_TRADING_ACCOUNT },
      { Header: TABLE_HEADER_HOLDINGS, accessor: JSON_KEY_INSTRUMENT },
      { Header: TABLE_HEADER_TOTAL, accessor: JSON_KEY_TOTAL },
      { Header: TABLE_HEADER_AVAILABLE, accessor: JSON_KEY_AVAILABLE },
      { Header: TABLE_HEADER_BUY_PENDING_APPROVAL, accessor: JSON_KEY_BUY_PENDING_APPROVAL },
      { Header: TABLE_HEADER_SELL_PENDING_APPROVAL, accessor: JSON_KEY_SELL_PENDING_APPROVAL },

//      { Header: TABLE_HEADER_STATUS, accessor: JSON_KEY_STATUS },
   ], []);

   return (
      <>
         <VirtualizedTablesTemplate
            columns={columns}
            eventHandlers={handleEvents}
            tableName="HoldingsTable"
            onRowClick={handleSingleClick}
            onRowDoubleClick={handleDoubleClick}
            onEmptyTableClick={handleEmptyTableClick}
            highlightOnClick={true}
            enableSearch={true}
            columnStyling={columnStyling}
         />
         <Modal show={showForm} onHide={handleCloseForm}>
            <HoldingsAdminForm rowData={selectedRow} onClose={handleCloseForm} tradingAccountOptions={dropDownTradingAccountsData} holdingsOptions={dropDownHoldingsData} />
         </Modal>

         <Modal show={showRequestForm} onHide={handleCloseRequestForm}>
            {showRequestForm && (<HoldingsRequestForm onClose={handleCloseRequestForm} tradingAccountOptions={dropDownTradingAccountsData} holdingsOptions={dropDownHoldingsData} />)}
         </Modal>
      </>
   );
};

export default Holdings2;
